/**
 * Copyright(c) 2024 Magrabi
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 *
 */

export const defaultLocale: any = process.env.SYSTEM_ENV_DEFAULT_LOCALE || "";
export const locales: any[] = process.env.SYSTEM_ENV_LOCALES?.split(",") || [];
export const seoInfo: {
  title: string;
  description: string;
  name: string;
} = {
  title: process.env.SYSTEM_ENV_TITLE || "",
  description: process.env.SYSTEM_ENV_TITLE || "",
  name: process.env.SYSTEM_ENV_TITLE || "",
};

export const fittingBoxApiKey = process.env.NEXT_PUBLIC_FITTING_BOX_API_KEY;
export const brandId: string = process.env.SYSTEM_BRAND_ID || process.env.NEXT_PUBLIC_BRAND_ID || "";
export const appId: string | undefined = process.env.SYSTEM_ID;
export const socketServerHost: string | undefined = process.env.NEXT_PUBLIC_SOCKET_SERVER_HOST;
export const tamaraPaymentPublicKey: string | undefined = process.env.TAMARA_PUBLIC_KEY;
export const tabbyPaymentPublicKey: string | undefined = process.env.TABBY_PUBLIC_KEY;
// Checkout.com Flow — public key for the Flow Web Component (UAE POC)
export const checkoutFlowPublicKey: string | undefined = process.env.NEXT_PUBLIC_CHECKOUT_FLOW_PUBLIC_KEY;
export const checkoutFlowEnvironment: string = process.env.NEXT_PUBLIC_CHECKOUT_FLOW_ENVIRONMENT ?? "sandbox";
export const googleMapsApiKey: string | undefined = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
export const revalidateTime = parseInt(process.env.NEXT_PUBLIC_REVALIDATE_TIME || "900", 10);
export const sanityRevalidateTime = parseInt(
  process.env.NEXT_PUBLIC_SANITY_REVALIDATE_TIME || "300",
  10,
);
export const olRevalidateTime = parseInt(process.env.NEXT_PUBLIC_OL_REVALIDATE_TIME || "86400", 10);
export const env = process.env.SYSTEM_ENV || "local";
export const baseURL = process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:3000";
export const cloudinaryCloudName: string | undefined =
  process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME;
export const azureCdnPath: string = process.env.NEXT_PUBLIC_AZURE_PATH ?? "";
export const cloudinaryFolderName: string = process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_NAME ?? "";
export const azureCdnPathForBrand: string = process.env.NEXT_PUBLIC_AZURE_PATH_BRAND ?? "";
export const cloudinaryFolderNameForBrand: string =
  process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_NAME_BRAND ?? "";

const envEnablePrefetch = process.env.NEXT_PUBLIC_ENABLE_PREFETCH_BY_DEFAULT;
export const enablePrefetchByDefault = envEnablePrefetch ? JSON.parse(envEnablePrefetch) : undefined;
export const isLocalEnv = env === "local";

export const disableErrorPageAutoReload =
  process.env.NEXT_PUBLIC_DISABLE_ERROR_PAGE_AUTO_RELOAD === "true";

export const algoliaConfig: {
  indexName: string;
  applicationID: string;
  searchApiKey: string;
} = {
  indexName: process.env.NEXT_PUBLIC_INDEX_NAME || "dev.magrabi",
  applicationID: process.env.NEXT_PUBLIC_APPLICATION_ID || "testingMM99Y48PMV",
  searchApiKey: process.env.NEXT_PUBLIC_SEARCH_API_KEY || "97a7c2a27e96afd6ab1c76a9a37c646b",
};

export const hasFallBackTranslation = process.env.HAS_FALL_BACK_TRANSLATION || "true";
